import clsx from 'clsx';
import { FormattedMessage, useIntl } from 'react-intl';
import { useState } from 'react';
import useConfirmationModal from './useConfirmationModal';
import useModal from './useModal';

const ModalFooter = () => {
	const [confirmAction, confirmationModal] = useConfirmationModal();
	const { id, editMode, onSubmitForm, confirmedAction, onClose, formattedMessagesOverrides, ref } = useModal();

	const intl = useIntl();
	const isSubmitting = ref?.current?.isSubmitting || false;
	const [isDeleting, setIsDeleting] = useState(false);

	const handleDeleteConfirmation = async () => {
		setIsDeleting(true);
		await confirmedAction(id);
		onClose();
	};

	return (
		<div className={clsx('modal-footer ', { 'd-flex justify-content-between': editMode && confirmedAction })}>
			{editMode ? confirmationModal : null}
			{editMode && confirmedAction ? (
				<button
					disabled={isSubmitting || isDeleting}
					type="button"
					className={clsx('btn btn-light-danger btn-color-danger', { loading: isDeleting })}
					onClick={() => confirmAction(() => handleDeleteConfirmation())}
				>
					<span>{formattedMessagesOverrides?.delete ?? <FormattedMessage id="GENERAL.DELETE" />}</span>
					{isDeleting ? (
						<div className="loader spinner-border spinner-border-sm" role="status">
							<span className="visually-hidden">Deleting...</span>
						</div>
					) : null}
				</button>
			) : null}
			<div>
				<button
					type="button"
					disabled={isSubmitting || isDeleting}
					className="generic-button fw-bold mx-5 fs-5"
					onClick={() => {
						onClose();
					}}
				>
					<FormattedMessage id="GENERAL.CANCEL" />
				</button>
				<button
					type="button"
					className={clsx('btn btn-primary', { loading: isSubmitting })}
					onClick={onSubmitForm}
					disabled={!onSubmitForm || isSubmitting || isDeleting}
				>
					<span>
						{editMode
							? formattedMessagesOverrides?.save ?? intl.formatMessage({ id: 'GENERAL.SAVE' })
							: formattedMessagesOverrides?.create ?? intl.formatMessage({ id: 'GENERAL.CREATE' })}
					</span>
					{isSubmitting ? (
						<div className="loader spinner-border spinner-border-sm" role="status">
							<span className="visually-hidden">Loading...</span>
						</div>
					) : null}
				</button>
			</div>
		</div>
	);
};

export default ModalFooter;
